import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export interface Testimonial {
  initials: string;
  quote: string;
  name: string;
  location: string;
}
interface TestimonialsProps {
  title?: string;
  testimonials: Testimonial[];
  columns?: 3 | 2;
}
export function Testimonials({
  title,
  testimonials,
  columns = 3
}: TestimonialsProps) {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-225" data-mp="36ypo6yluevgo">
      {title && <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-226" data-mp="31zw8r0mzwudv">
          {title}
        </motion.h2>}

      <div className={`grid grid-cols-1 md:grid-cols-2 ${columns === 3 ? 'lg:grid-cols-3' : ''} gap-6`} data-id="element-227" data-mp="v8wuid8blqea">
        {testimonials.map((t, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-brand-card border border-brand-green/10 rounded-2xl p-6 flex flex-col" data-id="element-228" data-mp="h5exrhxgzoz3" data-mpi={i}>
            <div className="flex items-center gap-4 mb-4" data-id="element-229" data-mp="zysbybcyrgs0">
              <div className="w-12 h-12 rounded-full bg-brand-green flex items-center justify-center text-white font-bold text-lg" data-id="element-230" data-mp="14u7omzz8j6mu">
                {t.initials}
              </div>
              <div className="flex text-brand-gold" data-id="element-231" data-mp="v4xu7dgx5bvk">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-232" data-mp="1iv223x153xsd" data-mpi={j} />)}
              </div>
            </div>
            <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-233" data-mp="1nnlc6k0mcasf">"{t.quote}"</p>
            <div className="text-sm font-medium text-gray-500" data-id="element-234" data-mp="1xi8z0ytsiv89">
              — {t.name}, {t.location}
            </div>
          </motion.div>)}
      </div>
    </section>;
}